module.exports = __webpack_public_path__ + "img/step_import_success.ee42f770.svg";